import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "schedule-view" }

import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getMonday } from '@/core/services/DateUtil';
import { Schedule } from '@/models/schedule.model';
import CountDown from '@/components/countdown/CountDown.vue';
import ScheduleDays from '@/components/schedule/ScheduleDays.vue';
import { Actions } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const schedule = computed<Schedule>(() => store.state.schedule);

const update = () => {
  let date = route.params.date || getMonday();
  store.dispatch(Actions.SetScheduleDate, date);
};

onMounted(() => {
  update();
  store.dispatch(Actions.GetSchedule);
});

watch(route, () => {
  update();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CountDown, {
      value: _unref(schedule).daysLeft
    }, null, 8, ["value"]),
    _createVNode(ScheduleDays)
  ]))
}
}

})